const elecrate_reducer = (state = 0, action) => {
	switch(action.type) {

		case 'SETELECRATE':
			return action.payload;

		default:
			return state;
	}
}

export default elecrate_reducer;
